<template>
    <div>
        <el-upload
            ref="upload"
            class="upload_box"
            :multiple="false"
            action="//a.ajmide.com/business/file_upload.php"
            :on-success="onSuccess"
            :on-progress="onProgress"
            :on-change="onChange"
            accept="image/png, image/jpeg"
            :before-upload="beforeUpload"
            :show-file-list="false"
        >
            <div class="btn_box">
                <div v-if="!originImgUrl">
                    <i
                        slot="trigger"
                        class="el-icon-plus avatar-uploader-icon"
                    ></i>
                </div>
                <div
                    v-else
                    class="pic_box"
                    :style="`background-image: url(${this.originImgUrl})`"
                    @mouseover="onMouseover"
                >
                    <el-progress
                        class="progress_box"
                        v-if="uploadPress > 0 && uploadPress < 100"
                        :text-inside="true"
                        :percentage="uploadPress"
                        :show-text="false"
                        :color="'#409eff'"
                    ></el-progress>
                    <div
                        v-show="actionsShow"
                        @mouseout="onMouseout"
                        class="actions"
                    >
                        <i slot="trigger" class="el-icon-upload"></i>
                        <i
                            @click="handlePictureCardPreview($event)"
                            class="el-icon-zoom-in"
                        ></i>

                        <i
                            @click="deletePic($event)"
                            class="el-icon-delete"
                        ></i>
                    </div>
                </div>
            </div>
        </el-upload>
        <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt="" />
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: 'UploadImage',
    props: ['value'],
    model: {
        prop: "value", //绑定的值，通过父组件传递
        event: "update" //自定义事件名
    },
    data() {
        return {
            previewStyle: null,
            uploadPress: 0,
            dialogImageUrl: '',
            // originImgUrl: '',
            dialogVisible: false,
            actionsShow: false,
        };
    },

    computed: {
        originImgUrl: {
            get() {
                return this.value ? this.value.url : '';
            },

            set(val) {
                this.value = {
                    url: val,
                    filename: ''
                };
            }
        }
    },

    methods: {

        onChange(file) {
            if (file.size <= 1024 * 1024 * 5) {
                this.originImgUrl = URL.createObjectURL(file.raw);
            }
        },

        beforeUpload(file) {
            if (file.size <= 1024 * 1024 * 5) {
                return true;
            } else {
                this.$alert('文件大小不能超过5M');
                this.$refs.upload.clearFiles();
                return false;
            }
        },

        onProgress(file) {
            this.uploadPress = file.percent;
        },

        onSuccess(response) {
            this.$emit("update", response.data);
        },

        onMouseover() {
            this.actionsShow = true;
        },
        onMouseout() {
            this.actionsShow = false;
        },
        handlePictureCardPreview(e) {
            e.stopPropagation();
            this.dialogImageUrl = this.originImgUrl;
            this.dialogVisible = true;
        },
        deletePic(e) {
            e.stopPropagation();
            this.$refs.upload.clearFiles();
            this.actionsShow = false;
            this.$emit("update", null);
        },
    },
};
</script>

<style scoped>
.el-upload {
}
.upload_box {
    overflow: hidden;
    line-height: 1;
}

.btn_box {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    background: transparent;
    width: 100%;
    height: 100%;
    border-color: transparent;
    line-height: 1;
}
.actions {
    position: absolute;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-around;
    background: rgba(0, 0, 0, 0.5);
}
.actions i {
    font-size: 26px;
    color: #fff;
}
.pic_box {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
}
.progress_box {
    width: 130px;
}
.progress_box_inner {
    height: 100%;
    background: #20a0ff;
}
</style>
